import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-22d4a4ea"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "df-settings-top"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "df-settings-top-title"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "df-settings-top-title-text"
}, "Settings")], -1));
const _hoisted_3 = {
  class: "df-settings-tabs"
};
const _hoisted_4 = {
  class: "df-settings-content"
};
const _hoisted_5 = {
  class: "df-settings-content-inner"
};
const _hoisted_6 = {
  class: "df-settings-bottom"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_app_tabs = _resolveComponent("app-tabs");
  const _component_demand_forecasting_settings_coverage = _resolveComponent("demand-forecasting-settings-coverage");
  const _component_demand_forecasting_settings_forecasting = _resolveComponent("demand-forecasting-settings-forecasting");
  const _component_app_button = _resolveComponent("app-button");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['df-settings', $data.tab])
  }, [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", {
    class: "df-settings-top-close",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.onClose && $options.onClose(...args))
  }, [_createVNode(_component_app_icon, {
    icon: "cross",
    size: 20,
    color: "#616161"
  })])]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_app_tabs, {
    modelValue: $data.tab,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.tab = $event),
    tabs: $data.tabs
  }, null, 8, ["modelValue", "tabs"])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [$data.tab == 'coverage' && $options.settingsInitialized ? (_openBlock(), _createBlock(_component_demand_forecasting_settings_coverage, {
    key: 0,
    settings: $data.settings,
    onUpdate: $options.onUpdateForecastingSettings
  }, null, 8, ["settings", "onUpdate"])) : _createCommentVNode("", true), $data.tab == 'forecasting' && $options.settingsInitialized ? (_openBlock(), _createBlock(_component_demand_forecasting_settings_forecasting, {
    key: 1,
    settings: $data.settings,
    onUpdate: $options.onUpdateForecastingSettings
  }, null, 8, ["settings", "onUpdate"])) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_app_button, {
    v2: "",
    onClick: $options.onSave
  }, {
    default: _withCtx(() => [_createTextVNode("Save")]),
    _: 1
  }, 8, ["onClick"])])], 2);
}